import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { DataGridContainer } from '../../Episode/Episode.Styled';
import { Auth } from 'aws-amplify';
import moment from 'moment';
import { CBP_INVOICES_LIST, dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';
import { useDispatch, useSelector } from 'react-redux';

const CBPInvoicesList = () => {
  //   const dispatch = useDispatch();
  const cbpId = useSelector((state) => state.cbpForm?.cboID);
  const [user, setUser] = useState(null);
  const [cbpInvoices, setCbpInvoices] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    page: 1,
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && cbpId) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    cbpInvoices.pageSize,
    cbpInvoices.page,
    cbpId,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    setCbpInvoices((old) => ({ ...old, isLoading: true }));
    const commonParams = `${CBP_INVOICES_LIST}/${cbpId}/invoices/list?PageNumber=${cbpInvoices.page}&PageSize=${cbpInvoices.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setCbpInvoices((old) => ({
        ...old,
        isLoading: false,
        total: response?.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          InvID: item.InvID,
          month: item.month ? item.month : '-',
          date: item.date
            ? moment(item.date).format(dateFormat).split('T')[0]
            : '-',
          dateSent: item.dateSent
            ? moment(item.dateSent).format(dateFormat).split('T')[0]
            : '-',
          dateFaxed: item.dateFaxed
            ? moment(item.dateFaxed).format(dateFormat).split('T')[0]
            : '-',
          dateReceived: item.dateReceived
            ? moment(item.dateReceived).format(dateFormat).split('T')[0]
            : '-',
          signed: item.signed,
          amount: `$${item.amount}`,
        })),
      }));
    }).catch((e) => alert(e));
  };

  //   const cbpFoodRowClick = (rowData) => {
  //     setOpenCBPFoodDialog(true);
  //   };

  const ColumnsData = [
    {
      field: 'InvID',
      headerName: 'InvID',
      sortable: false,
      flex: 1,
    },
    {
      field: 'month',
      headerName: 'Month',
      sortable: false,
      flex: 1,
    },
    {
      field: 'date',
      headerName: 'Date',
      type: 'date',
      sortable: false,
      flex: 1,
    },
    {
      field: 'dateSent',
      headerName: 'Date Sent',
      type: 'date',
      sortable: false,
      flex: 1,
    },
    {
      field: 'dateFaxed',
      headerName: 'Date Faxed',
      sortable: false,
      type: 'date',
      flex: 1,
    },
    {
      field: 'dateReceived',
      headerName: `Date Rec'd`,
      sortable: false,
      type: 'date',
      flex: 1,
    },
    {
      field: 'signed',
      headerName: 'Signed?',
      sortable: false,
      type: 'boolean',
      flex: 1,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      sortable: false,
      flex: 1,
    },
  ];

  return (
    <>
      <DataGridContainer>
        <DataGrid
          getRowHeight={() => 'auto'}
          columns={ColumnsData}
          rows={cbpInvoices.data}
          rowCount={cbpInvoices.total}
          rowsPerPageOptions={[10, 25, 50]}
          pageSize={cbpInvoices.pageSize}
          pagination
          paginationMode='server'
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          onPageSizeChange={(newPageSize) =>
            setCbpInvoices((prveState) => ({
              ...prveState,
              pageSize: newPageSize,
            }))
          }
          onPageChange={(newPage) => {
            setCbpInvoices((prveState) => ({
              ...prveState,
              page: newPage + 1,
            }));
          }}
          loading={cbpInvoices.isLoading}
          //onRowClick={(param) => cbpFoodRowClick(param.row)}
          disableColumnFilter
          disableColumnMenu
        />
      </DataGridContainer>
    </>
  );
};

export default CBPInvoicesList;
